/* eslint-disable max-len */
import { defineMessages, useIntl } from 'react-intl';
import { NumberInput } from '@mantine/core';

import { useEventContext } from 'Screens/Dashboard/Events/EventHandler/EntityEventContext';
import sharedMessages from 'Components/utils/sharedMessages';

const EveryDayRecurrenceInput = () => {
    const intl = useIntl();
    const { values, updateValues } = useEventContext();

    const value = values.recurrence.daily?.interval ?? 1;

    const updateEveryXDay = (interval: number | string) => {
        updateValues({
            recurrence: {
                ...values.recurrence,
                daily: {
                    ...values.recurrence.daily,
                    interval: Number(interval) || 1,
                },
            },
        });
    };

    return (
        <div style={{ maxWidth: '200px' }}>
            <NumberInput
                id="every-day-recurrence-input"
                label={intl.formatMessage(messages.label)}
                max={20}
                min={1}
                onChange={updateEveryXDay}
                size="md"
                step={1}
                value={value}
                radius="md"
                error={value < 1 || value > 20 ? intl.formatMessage(sharedMessages.invalidValue) : undefined}
            />
        </div>
    );
};

const messages = defineMessages({
    label: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventRecurrence.EveryDayRecurrence.EveryDayRecurrenceInput.EveryDayRecurrenceInput.label',
        defaultMessage: 'Co ile dni?',
    },
});

export default EveryDayRecurrenceInput;
